import { render, staticRenderFns } from "./BrandDetails.vue?vue&type=template&id=489cb05e&scoped=true&"
import script from "./BrandDetails.vue?vue&type=script&lang=ts&"
export * from "./BrandDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BrandDetails.vue?vue&type=style&index=0&id=489cb05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cb05e",
  null
  
)

export default component.exports